import { clsx } from 'clsx'

type RtlClassMap = {
  ltr: string
  rtl: string
  common?: string
}

export const rtlClasses = (
  isRtl: boolean,
  classMap: RtlClassMap | string,
  additionalClasses?: string,
): string => {
  if (typeof classMap === 'string') {
    return clsx(classMap, additionalClasses)
  }

  const { ltr, rtl, common } = classMap
  const directionalClass = isRtl ? rtl : ltr

  return clsx(common, directionalClass, additionalClasses)
}

export const rtlTextAlign = (isRtl: boolean): string =>
  isRtl ? 'rtl-text-right' : 'text-left'

export const rtlMarginStart = (isRtl: boolean, size: string): string =>
  isRtl ? `mr-${size}` : `ml-${size}`

export const rtlMarginEnd = (isRtl: boolean, size: string): string =>
  isRtl ? `ml-${size}` : `mr-${size}`

export const rtlPaddingStart = (isRtl: boolean, size: string): string =>
  isRtl ? `pr-${size}` : `pl-${size}`

export const rtlPaddingEnd = (isRtl: boolean, size: string): string =>
  isRtl ? `pl-${size}` : `pr-${size}`

export const rtlFlexDirection = (
  isRtl: boolean,
  enableReverse = false,
): string => {
  if (!isRtl || !enableReverse) {
    return 'flex-row'
  }
  return 'flex-row-reverse'
}
